// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__uSUX7","col":"styles_col__T0NkC"};